import React from 'react';
import Accordion from '../../common/accordion/accordion';
import { AemFAQs } from '../../../models/experiencefragments/category-view';

import './faqs-accordion-no-disclaimer.scss';
interface Props {
    faqs: AemFAQs;
    origin?: string;
}
export const FaqsAccordionNoDisclaimer = (props: Props) => {
    const faqs = props.faqs;
    return (
        <article className="faqs-accordion-no-disclaimer-container">
            {faqs.title && (
                <h2 className="faqs-accordion-no-disclaimer-title">
                    {faqs.title}
                </h2>
            )}
            {faqs.subtitle && (
                <h3 className="faqs-accordion-no-disclaimer-subtitle">
                    {faqs.subtitle}
                </h3>
            )}
            <section className="faqs-accordion-no-disclaimer-wrapper">
                {faqs.questions.map((faq, index) => {
                    return (
                        <Accordion
                            key={faq.question}
                            header={faq.question}
                            panel={
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: faq.text,
                                    }}
                                />
                            }
                            className="faqs-question"
                            index={index.toString()}
                            expandMultiplePanels={true}
                            useHTag={true}
                            origin={props.origin}
                        />
                    );
                })}
            </section>
        </article>
    );
};
